var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-qr" }, [
    _c(
      "div",
      { staticClass: "upload-qr-header" },
      [
        _c("span", { staticClass: "upload-qr-header-text" }, [
          _vm._v(_vm._s(_vm.$t("views.uploadQr.header"))),
        ]),
        _c(
          "IconComponent",
          { staticClass: "upload-qr-close", on: { click: _vm.onCloseClick } },
          [_vm._v("close")]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "upload-qr-body" }, [
      _c("div", { staticClass: "upload-qr-image-container" }, [
        _c("img", {
          staticClass: "upload-qr-image",
          attrs: { src: _vm.qrImage },
        }),
      ]),
      _c("div", { staticClass: "upload-qr-image-text" }, [
        _vm._v(_vm._s(_vm.$t("views.uploadQr.imageText"))),
      ]),
    ]),
    _c("div", { staticClass: "upload-qr-footer" }, [
      _c("span", { staticClass: "upload-qr-footer-text" }, [
        _vm._v(_vm._s(_vm.$t("views.uploadQr.footer"))),
      ]),
      _c(
        "span",
        { staticClass: "upload-qr-link", on: { click: _vm.onCopyLink } },
        [_vm._v(_vm._s(_vm.$t("views.uploadQr.linkText")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }